import React from "react";
import ReportingChart from "../Reporting/ReportingChart";
import _ from "lodash";
import gql from "graphql-tag";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";

const ECRITURELINE_CREATED_SUBSCRIPTION = gql`
  subscription onEcritureLineCreated($companyId: ID!) {
    ecritureLineCreated(companyId: $companyId) {
      id
      journal
      amount
      libelle
      libelleExport
      dateOperation
      dateLettrage
      labelLettrage
      tiersClient {
        id
      }
      project {
        id
        tiersClient {
          id
        }
      }
      article {
        id
      }
      category {
        id
      }
    }
  }
`;

const ECRITURELINE_UPDATED_SUBSCRIPTION = gql`
  subscription onEcritureLineUpdated($companyId: ID!) {
    ecritureLineUpdated(companyId: $companyId) {
      id
      journal
      amount
      libelle
      libelleExport
      dateOperation
      dateLettrage
      labelLettrage
      tiersClient {
        id
      }
      project {
        id
        tiersClient {
          id
        }
      }
      article {
        id
      }
      category {
        id
      }
    }
  }
`;

const ECRITURELINE_DELETED_SUBSCRIPTION = gql`
  subscription onEcritureLineDeleted($companyId: ID!) {
    ecritureLineDeleted(companyId: $companyId) {
      id
      journal
      amount
      libelle
      libelleExport
      dateOperation
      dateLettrage
      labelLettrage
      tiersClient {
        id
      }
      project {
        id
        tiersClient {
          id
        }
      }
      article {
        id
      }
      category {
        id
      }
    }
  }
`;

const LETTRAGE_DONE = gql`
  subscription onEcritureLineLettrageDone($companyId: ID!) {
    ecritureLineLettrageDone(companyId: $companyId) {
      date
    }
  }
`;

class TaxReportChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingMore: false
    };
    this.startCursorArray = [];
  }

  componentDidUpdate() {
    // console.log("114 - data=", this.props.data);

    const data =
      this.props.data && this.props.data.ecritureLinesConnectionForTaxes;

    if (!!!data) {
      // console.log("120 - no data...");
      this.startCursorArray = [];
      return;
    }

    const pageInfo = data && data.pageInfo;
    // console.log("125 - pageInfo=", pageInfo);

    const startCursor = pageInfo && pageInfo.startCursor;
    if (this.startCursorArray.includes(startCursor)) {
      // console.log("125 - already in array:", startCursor);
      return;
    }
    else
      this.startCursorArray.push(startCursor);
    // console.log("133 - added array=", this.startCursorArray);

    if (pageInfo.hasNextPage) {
      console.log("134 - LoadMore...", startCursor);
      this.props.onLoadMore(
        pageInfo.endCursor,
        "ecritureLinesConnectionForTaxes"
      );
    }

    if (
      (pageInfo && pageInfo.hasNextPage === false)
    ) {
      if (this.state.loadingMore === true)
        this.setState({ loadingMore: false });
      // console.log("152 - loadingMore=", this.state.loadingMore);
    }

    if (
      (pageInfo && pageInfo.hasNextPage === true)
    ) {
      if (this.state.loadingMore === false)
        this.setState({ loadingMore: true });
      // console.log("160 - loadingMore=", this.state.loadingMore);
    }
  }

  componentDidMount() {
    // console.log("104 - TaxReportChart.componentDidMount", this);

    this.startCursorArray = [];
    if (!this.props.data) return;

    // this.startCursorArray = [];

    // ecritureLineCreated
    if (this.unsubscribeEcritureLineCreated)
      this.unsubscribeEcritureLineCreated();
    this.unsubscribeEcritureLineCreated = this.props.subscribeToMore({
      document: ECRITURELINE_CREATED_SUBSCRIPTION,
      variables: {
        companyId: this.props.companyId
      },

      updateQuery: (prev, { subscriptionData }) => {
        // console.log("176 - ECRITURELINE_CREATED_SUBSCRIPTION...");
        this.startCursorArray = [];
        this.props.refetch();

        if (!subscriptionData.data) {
          return prev;
        }
        return prev;
      }
    });

    // ecritureLineUpdated
    if (this.unsubscribeEcritureLineUpdated)
      this.unsubscribeEcritureLineUpdated();
    this.unsubscribeEcritureLineUpdated = this.props.subscribeToMore({
      document: ECRITURELINE_UPDATED_SUBSCRIPTION,
      variables: {
        companyId: this.props.companyId
      },

      updateQuery: (prev, { subscriptionData }) => {
        //this.props.refetch();

        if (!subscriptionData.data) {
          return prev;
        }
        return prev;
      }
    });

    // ecritureLineDeleted
    if (this.unsubscribeEcritureLineDeleted)
      this.unsubscribeEcritureLineDeleted();
    this.unsubscribeEcritureLineDeleted = this.props.subscribeToMore({
      document: ECRITURELINE_DELETED_SUBSCRIPTION,
      variables: {
        companyId: this.props.companyId
      },

      updateQuery: (prev, { subscriptionData }) => {
        this.startCursorArray = [];
        this.props.refetch();

        if (!subscriptionData.data) {
          return prev;
        }
        return prev;
      }
    });

    // lettageDoneCreated
    if (this.unsubscribeLettageDone)
      this.unsubscribeLettageDone();
    this.unsubscribeLettageDone = this.props.subscribeToMore({
      document: LETTRAGE_DONE,
      variables: {
        companyId: this.props.companyId
      },

      updateQuery: (prev, { subscriptionData }) => {
        this.startCursorArray = [];
        this.props.refetch();

        if (!subscriptionData.data) {
          return prev;
        }
        return prev;
      }
    });
    return;
  }

  componentWillUnmount() {
    if (this.unsubscribeEcritureLineCreated)
      this.unsubscribeEcritureLineCreated();

    if (this.unsubscribeEcritureLineUpdated)
      this.unsubscribeEcritureLineUpdated();

    if (this.unsubscribeEcritureLineDeleted)
      this.unsubscribeEcritureLineDeleted();

    if (this.unsubscribeLettageDone)
      this.unsubscribeLettageDone();
  }

  static getDerivedStateFromProps = async (props, state) => {
    // console.log("230 - getDerivedStateFromProps", props);

    if (
      props &&
      props.data &&
      props.data.ecritureLinesConnectionForTaxes
    ) {
      state.data = props.data;

      let edges =
        state &&
        state.data &&
        state.data.ecritureLinesConnectionForTaxes &&
        state.data.ecritureLinesConnectionForTaxes.edges;

      // TRANSLATIONS.....
      _.forEach(edges, o => {
        if (o.node && o.node.category && o.node.category.ids !== null) {
          // console.log("=>", o.node.category.ids);
          o.node.category.name = props.intl.formatMessage({
            id: o.node.category.ids
          });
        }

        if (
          o.node &&
          o.node.category &&
          o.node.category &&
          o.node.category.categoryFamily &&
          o.node.category.categoryFamily.ids !== null
        ) {
          o.node.category.categoryFamily.name = props.intl.formatMessage({
            id: o.node.category.categoryFamily.ids
          });
        }

        if (o.node && o.node.tiersClient && o.node.tiersClient.id === "FAKE_ID_CLIENT") {
          o.node.tiersClient.name = props.intl.formatMessage({
            id: o.node.tiersClient.name
          });
        }
        if (o.node && o.node.project && o.node.project.id === "FAKE_ID_PROJECT") {
          o.node.project.name = props.intl.formatMessage({
            id: o.node.project.name
          });
        }
      });

      if (edges) {
        // edges = _.orderBy(
        //   edges,
        //   [
        //     "node.project.name",
        //     "node.category.name",
        //     "node.tiers.name",
        //     "node.article.name",
        //     "node.category.categoryFamily.name",
        //     "node.category.name"
        //   ],
        //   ["asc", "asc", "asc", "asc", "asc", "asc"]
        // );
        state.data.ecritureLinesConnectionForTaxes.edges = edges;
      }
    }
  };

  render() {
    // console.log("235 - TaxReportChart.render");

    const edges =
      this.state.data &&
      this.state.data.ecritureLinesConnectionForTaxes &&
      this.state.data.ecritureLinesConnectionForTaxes.edges;

    return (
      <div>
        <ReportingChart
          {...this.props}
          loadingMore={this.state.loadingMore}
          edges={edges}
          negateValues={false}
          type="taxes"
          showProductColumn={false}
          // tabs={["categories", "tiersAsSupplier", "project", "client"]}
          tabs={["taxes"]}
          onRowClick={(row, state, rowInfo, column, instance) => {
            if (rowInfo.original.expenseId) {
              this.props.history.push(
                `/expenses/${rowInfo.original.expenseId}/edit`
              );
            }
            if (rowInfo.original.invoiceId) {
              this.props.history.push(
                `/invoices/${rowInfo.original.invoiceId}/edit`
              );
            }
            if (rowInfo.original.bankTransactionId) {
              this.props.history.push(
                `/payments/${rowInfo.original.bankTransactionId}/affectation`
              );
            }
          }}
        />
      </div>
    );
  }
}

export default withRouter(injectIntl(TaxReportChart));
